import { Alert } from '@mui/material';
import {
  selectedGridRowsCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import FormDrawer from 'components/drawers/form-drawer/form-drawer.component';
import { IncDrawerType } from 'components/drawers/inc-drawer/inc-drawer.component';
import { useTranslation } from 'react-i18next';
import { BulkEditGridColDef } from '../bulk-edit-data-grid.types';
import { ToolbarProps } from '../inc-data-grid.component';
import BulkEditDefaultFields from './bulk-edit-default-fields/bulk-edit-default-fields.component';
import { useBulkEditForm } from './bulk-edit-drawer.hooks';

export type BulkEditDrawerDataType = Partial<{
  column: BulkEditGridColDef;
  bulkEdit: ToolbarProps['bulkEdit'];
  defaultValues: any;
}>;

type BulkEditDrawerProps = IncDrawerType<BulkEditDrawerDataType>;

const BulkEditDrawer = ({ data, close, isOpen }: BulkEditDrawerProps) => {
  const { t } = useTranslation();
  const api = useGridApiContext();
  const selectedRowCount = useGridSelector(api, selectedGridRowsCountSelector);

  const form = useBulkEditForm(data);
  const FormComponent = data?.bulkEdit.fields[data.column.field].FormComponent;

  return (
    <FormDrawer
      onClose={close}
      open={isOpen}
      onValid={async value => {
        await data?.bulkEdit?.onValid(value);
        close();
      }}
      title={t('IncDataGrid.BulkEditDrawer.title')}
      formMethods={form}
      cancel={() => {
        form.reset();
        close();
      }}
    >
      <Alert severity="info">
        {t('IncDataGrid.BulkEditDrawer.rows', { count: selectedRowCount })}
      </Alert>
      {FormComponent ? (
        FormComponent
      ) : (
        <BulkEditDefaultFields column={data?.column} />
      )}
    </FormDrawer>
  );
};
export default BulkEditDrawer;
